import {
    GetFormalOffersResponse,
    GetIwocapayPaymentLaterResponse
} from '@iwoca/lapi-client/edge';

import { mapOfferDurationToProduct } from './mapOfferDurationToProduct';

export const filterAvailableDurationsByPayLink = ({
    offers,
    payLink
}: {
    offers: NonNullable<
        NonNullable<GetFormalOffersResponse['data']>['formal_offers']
    >;
    payLink: GetIwocapayPaymentLaterResponse['data'][number];
}) => {
    const supportedProducts = Object.keys(payLink.product_pricing!);
    if (!supportedProducts) return [];

    return offers.filter((offer) => {
        if (offer.product_type !== 'iwocapay') return;

        const isNotEnoughCredit = offer.available_credit! < payLink.amount;
        if (isNotEnoughCredit) return;

        const product = mapOfferDurationToProduct(offer);
        if (!product) return;

        return supportedProducts.includes(product.toString());
    });
};
